export default __webpack_public_path__ + "static/media/IndexPrompt.fa0fa206.png";